import React from 'react'
import type { Icon } from 'shared/utils'
import { transformations } from 'shared/utils'
import styled from 'styled-components'
import { media } from 'app/assets/styles'

const CircleChevron = (props: Icon) => {
    const {
        color = 'white',
        background = 'black',
        size = 40,
        direction = 'right',
        className = 'circle-chevron'
    } = props
    return (
        <Svg
            width={size}
            height={size}
            className={className}
            style={{ transform: transformations[direction] }}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <Circle
                    className={className}
                    cx={20}
                    cy={20}
                    r={20}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M16.913 16.262l3.817 3.825-3.817 3.825 1.175 1.175 5-5-5-5z"
                />
            </g>
        </Svg>
    )
}

const Circle = styled.circle`
    &.carouselChevron {
        fill-opacity: 0.5;
    }
`

const Svg = styled.svg`
    &.carouselChevron {
        width: 40px;
        height: 40px;
        ${media.medium`
            width: 70px;
            height: 70px;
        `};
    }
`

export { CircleChevron }
